import chooseHomePageView from './chooseHomePageComponent.html';
import './chooseHomePageComponent.css';

export function chooseHomePageComponent() {
	return {
		controllerAs: 'vm',
		controller: chooseHomePageComponentCtrl,
		template: chooseHomePageView,
	};
}

export class chooseHomePageComponentCtrl {
	constructor(Cfg, $location, UrlData) {
		'ngInject';
		this.Cfg = Cfg;
		this.$location = $location;
		this.UrlData = UrlData;
	}

	$onInit() {
		this.showChooseHome();
	}

	showChooseHome() {
		const homePage = this.Cfg.read('Features.home_page');
		const url = this.$location.absUrl();

		const [, homePath] = url.split('hub#/');
		if (homePage && homePage.includes('/hub') && homePath && homePath.includes('posts?finetune')) {
			this.isHomePage = true;
		} else {
			this.isHomePage = false;
		}
	}

	makeDefaultPage() {
		this.Cfg.write('Features.home_page', '/hub#/posts', 'user').then(() => {
			this.showChooseHome();
		});
	}
}
